import { AbstractCommand } from 'src/models/command';

class CreateANewMemoCommand extends AbstractCommand {
	readonly name = 'IFS_IDO_IdoActivity_Command_Commands_CreateIdoActivityAndReturnAggregateId';

	public constructor(idoId: string, instanceId: string) {
		super();
		this.parameters = {
			idoId: idoId,
			instanceId: instanceId,
		};
	}
}

export { CreateANewMemoCommand };
